import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Docente } from '../models/didattica/docente';
import { Studente } from '../models/didattica/studente';

import { Utente } from '../models/utente';
import { AuthService } from './auth-service/auth-service';
import { UtilityService } from './utility.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * Espone e servizi relativi all'utente corrente, profili, etc
*/
@Injectable( { providedIn: 'root' })
export class UserService {

  constructor(public http: HttpClient,
    private authService: AuthService,
    private translateService: TranslateService,
    private utilityService: UtilityService) {
    console.log('Hello UserService Provider');
  }
  public utente: Utente;
  private me: any; // raw
  private docenteImpersonato: Docente;
  private studenteImpersonato: Studente;

  fromext = false;

  init(): Observable<any> { // verificare come tipizzare il ritorno
    console.log( ' init ');
    if (this.utente) {
      console.log( 'user ' + JSON.stringify( this.utente) );
      return of(this.utente);
    } else {
      const headers = {headers: new HttpHeaders({'X-Calling-Client':  'PWA'})};
      return this.http.get<Utente>('me', headers).pipe(
          map( this.parseUtente, this )
          // , catchError(err => {
          //   console.log( 'err ' , err );
          //   this.http.get('https://unime.openid.pp.cineca.it/oauth2/logout')
          //     .subscribe(
          //       data => { console.log('data logout ', data); },
          //       err2 => {  console.log( 'err ' , err2 ); }
          //     );
          //   throw err;
          // })
          );
    }
  }

  getUserType(): string {
    let usertype = 'pta';
    if (this.isDocente()) {
      usertype = 'docente';
    } else if (this.isStudente()) {
      usertype = 'studente';
    } else if (this.isPTA() ) {
      usertype = 'pta';
    }
    return usertype;
  }

  oauthLogout(logoutUrl: string): Observable<any> {
    return this.http.get( logoutUrl ) ;
  }

  cleanup() {
    this.utente = undefined;
    this.me = undefined;
    this.docenteImpersonato = undefined;
    this.studenteImpersonato = undefined;
  }

     // parsing della risposta e aggiunta di eventuali metodi di businness
     private parseUtente(ute: Utente) {
      // console.log( 'ute' , ute);
      if (ute) {
        this.me = ute;
        this.utente = Object.assign(ute, {
          nominativo: function () { return `${this.cognome} ${this.nome}`; }
      });
      console.log('utente ' + JSON.stringify( this.utente) );
     }
    }
   // parsing della risposta e aggiunta di eventuali metodi di businness
  // private parseResponse(response: Response) {
  //   if (response.ok) {
  //     this.me = response.json();
  //     this.utente = {
  //       id: this.me.id,
  //       username: this.me.username,
  //       cognome: this.me.cognome,
  //       nome: this.me.nome,
  //       ruolo: this.me.ruolo,
  //       nominativo: function () { return `${this.nome} ${this.cognome}`; }
  //     };
  //     return this.utente;
  //   } else {
  //     throw response;
  //   }
  // }

  getUtenteCorrente(): Utente {
    return this.utente;
  }

  impersonamentoInCorso(): boolean {
    return this.docenteImpersonato != null || this.studenteImpersonato != null;
  }

   // impersona un docente
  impersonaDocente(doc: Docente) {
    this.docenteImpersonato = doc;
  }

   // impersona uno studente
  impersonaStudente(stu: Studente) {
    this.studenteImpersonato = stu;
  }

   // return true se l'utente loggato è un docente
  isDocente(): boolean {
    return this.utente.ruolo === 'docente';
  }

   // return true se l'utente loggato è uno studente
  isStudente(): boolean {
    return this.utente.ruolo === 'studente';
  }

  // return true se l'utente loggato è un PTA
  isPTA(): boolean {
    return this.utente.ruolo === 'pta';
  }

   // questi metodi saranno utili per l'introduzione dell'impersonamento da parte dei pta
   // al momento tornano degli oggetti popolati con i dati del utente loggato

  getDocenteCorrente(): Docente {

    if (this.isDocente()) {
      return {
        id: this.utente.id,
        cognome: this.utente.cognome,
        nome: this.utente.nome,
        email: this.utente.email,
        nominativo: this.utente.nominativo()
      };
    } else {
      return this.docenteImpersonato;
    }
  }

  getStudenteCorrente(): Studente {
    if (this.isStudente()) {
      return {
        id: this.utente.id,
        cognome: this.utente.cognome,
        nome: this.utente.nome,
        matricola: this.utente.matricola,
        // nominativo: this.utente.nominativo
      };
    } else {
      return this.studenteImpersonato;
    }
  }

  callFromext(extToken): Observable<any> {
    console.log( 'callFromExt', extToken);

    console.log('localUrlcfe', 'http://localhost:8100/assets/html/callfromext.html#' + extToken);

    this.fromext = true;
    const headers = {headers: new HttpHeaders({'Authorization': `Bearer ${extToken}`})};
    const carreerId = this.authService.getStuId();
    const meUrl = carreerId ? `me/${carreerId}` : 'me';
    return this.http.get<Utente>(meUrl, headers).pipe(
          map( this.parseUtente, this )
          , catchError(err => {
            console.log( 'err ' , err );
            throw err;
          })
       );
  }

}
